import { render, staticRenderFns } from "./AuditNearExpiryManualServices.vue?vue&type=template&id=b255324c&scoped=true&"
import script from "./AuditNearExpiryManualServices.vue?vue&type=script&lang=js&"
export * from "./AuditNearExpiryManualServices.vue?vue&type=script&lang=js&"
import style0 from "./AuditNearExpiryManualServices.vue?vue&type=style&index=0&id=b255324c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b255324c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VRow,VSkeletonLoader,VTextField})
